import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    day: 'Día 1',
    title: 'Descompresión',
    desc: 'Eliminamos los químicos que retienen líquidos y calmamos tu sistema nervioso.'
  }, {
    day: 'Día 2',
    title: 'Reset',
    desc: "Introducimos los nutrientes 'oro líquido' que reparan la pared de tu intestino."
  }, {
    day: 'Día 3',
    title: 'Energía',
    desc: 'Restauramos tu vitalidad sin disparar la insulina, preparándote para un lunes ligero.'
  }];
  return <section className="bg-beige py-20 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <FadeIn data-id="element-76">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-77">
            ¿Cómo <span className="italic text-terracotta" data-id="element-78">funciona</span>?
          </h2>

          <div className="space-y-8 relative" data-id="element-79">
            {/* Connecting line */}
            <div className="hidden md:block absolute left-8 top-8 bottom-8 w-0.5 bg-terracotta opacity-30" data-id="element-80"></div>

            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-81">
                <div className="flex flex-col md:flex-row items-start md:items-center relative" data-id="element-82">
                  <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-8 relative z-10" data-id="element-83">
                    <div className="w-16 h-16 bg-terracotta text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg font-heading" data-id="element-84">
                      {index + 1}
                    </div>
                  </div>
                  <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm flex-grow border border-cream w-full" data-id="element-85">
                    <div className="text-sm font-bold text-terracotta uppercase tracking-wider mb-2" data-id="element-86">
                      {step.day}
                    </div>
                    <h3 className="text-2xl font-bold text-brown-dark mb-3" data-id="element-87">
                      {step.title}
                    </h3>
                    <p className="text-brown-body text-lg" data-id="element-88">{step.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}